import { cond, T } from 'ramda'
import { isLocal, isDev, isQA, isProd } from '../environments'

const environment = cond([
  [isLocal, () => 'dev-'],
  [isDev, () => 'dev-'],
  [isQA, () => 'qa-'],
  [isProd, () => 'prod-'],
  [T, () => 'dev-'],
])(window.location.hostname)

/**
 * builds the doctor img depending on the environment and npi
 * @param {obj} doctor
 */
export default (doctor, npiField = 'npi') =>
  `https://${environment}doctor-image.sidecarhealth.com/care-providers/${doctor[npiField]}.png`
